
import React from 'react';
import { ChatProvider, useChatContext } from './ChatContext';
import { ChatWindow } from './ChatWindow';
import { ChatToggle } from './ChatToggle';
import { motion, AnimatePresence } from 'framer-motion';

// Inner component using the chat context
const LiveChatInner: React.FC = () => {
  const { isChatOpen } = useChatContext();
  
  return (
    <>
      <ChatToggle />
      
      <AnimatePresence>
        {isChatOpen && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ duration: 0.2 }}
            className="fixed bottom-20 right-5 w-[350px] h-[500px] max-h-[80vh] z-50"
          >
            <ChatWindow />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

// Outer component providing the chat context
export const LiveChatWidget: React.FC = () => {
  return (
    <ChatProvider>
      <LiveChatInner />
    </ChatProvider>
  );
};
